import {
  EstimateNoiseMapController,
  NoiseMapContent,
} from './components/EstimateNoiseMap'

export { default } from './EstimateNoise'

export const EstimateNoiseMapConfig = {
  Controller: EstimateNoiseMapController,
  Content: NoiseMapContent,
}
